import { render, staticRenderFns } from "./HistorialTurnos.vue?vue&type=template&id=e056e018"
import script from "./HistorialTurnos.vue?vue&type=script&lang=js"
export * from "./HistorialTurnos.vue?vue&type=script&lang=js"
import style0 from "./HistorialTurnos.vue?vue&type=style&index=0&id=e056e018&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports